import React from 'react';
import { FadeIn } from './FadeIn';
import { Sparkles } from 'lucide-react';
export const ProofSection = () => {
  return <section className="py-24 px-4 relative" data-id="element-179">
      <div className="max-w-4xl mx-auto text-center" data-id="element-180">
        <FadeIn data-id="element-181">
          <div className="inline-block relative" data-id="element-182">
            <div className="absolute inset-0 bg-gold/8 blur-2xl rounded-full" data-id="element-183"></div>
            <div className="relative bg-gold-light/20 border border-gold/25 rounded-2xl p-8 md:p-12" data-id="element-184">
              <Sparkles className="text-gold-antique mx-auto mb-6" size={32} data-id="element-185" />
              <p className="text-xl md:text-2xl font-playfair text-brown-heading leading-relaxed italic mb-6" data-id="element-186">
                "En los próximos 7 días, al aplicar la técnica de 'Sustitución
                de Vacío' de RENACER, notarás un cambio físico real..."
              </p>
              <p className="text-lg text-brown-warm/70 leading-relaxed" data-id="element-187">
                ...una ligereza en el pecho y la aparición de "sincronicidades"
                que confirmarán que el campo cuántico ha empezado a responder a
                tu nueva señal.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};